
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal } from "../../../features/modal/modalSlice";
import { deleteKayitliYuk, getKayitliYukForUpdate } from "../../../features/kayit/kayitSlice";
import Btn from "../../shared/button/Btn";
import { setLoadItemData } from "../../../features/loadList/loadListSlice";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 600px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    padding-top: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      padding: 40px 0;
      width: 800px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
  }


  @media (max-width: 850px) {
    .modal{
        width: 100vw;
        height: 100vh;
        justify-content: center !important;
    }

  }

`;

const YukKayitItemOptionsModal = () => {
  const dispatch = useDispatch();
  const [isLoadingUpdateDetails, setIsLoadingUpdateDetails] = useState(false);

  const location = useLocation();

  const {selectedKayitliYuk, isLoadingDeleteKayitliYuk}= useSelector(state => state.kayit)

  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleUpdate = async () => {
    if (!selectedKayitliYuk?.id || isLoadingUpdateDetails) return;

    setIsLoadingUpdateDetails(true);
    try {
      const registeredLoad = await dispatch(
        getKayitliYukForUpdate(selectedKayitliYuk.id)
      ).unwrap();
      dispatch(setLoadItemData(registeredLoad));
      dispatch(showModal("kayitliYukGuncelle"));
    } catch {
      // API hatası thunk içinde backend mesajıyla gösteriliyor.
    } finally {
      setIsLoadingUpdateDetails(false);
    }
  };


  return (
    <ModalContainer onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="content">
          <Btn
            color={"#fff"}
            bgColor={"#E85446"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            isDisabled={isLoadingDeleteKayitliYuk}
            handleClick={() => dispatch(deleteKayitliYuk({id:selectedKayitliYuk?.id}))}
          >
            {isLoadingDeleteKayitliYuk ? "Siliniyor..." : "Kayıtlı Yükü Sil"}
          </Btn>
          <Btn
            color={"#fff"}
            bgColor={"#E85446"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            isDisabled={isLoadingUpdateDetails}
            handleClick={handleUpdate}
          >
            {isLoadingUpdateDetails ? "Yük bilgileri getiriliyor..." : "Kayıtlı Yükü Güncelle"}
          </Btn>
          <Btn
            color={"#fff"}
            bgColor={"#E85446"}
            width="280px"
            radius={"10px"}
            fontSize="14px"
            handleClick={() => {
                dispatch(showModal(null));
            }}
          >
            Geri
          </Btn>
        </div>
      </div>
    </ModalContainer>
  );
};

export default YukKayitItemOptionsModal
